<template>
  <v-container fluid tag="section">
      <base-material-dialog
        title='专利编辑'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='600'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-3" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field hide-details="auto" label="专利名称" outlined :rules="required" placeholder="请输入专利名称" v-model="form.name"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field hide-details="auto" label="申请人名称" outlined  placeholder="请输入申请人名称" v-model="form.applyUser"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" label="专利编号" outlined :rules="required" placeholder="请输入专利名称" v-model="form.patentCode"></v-text-field>
                  </v-col>
                  <v-col cols="12" md='6'>
                    <v-select
                      :items="[{ text: '有费减', value: 1 },{ text: '无费减', value: 2 }]"
                      label="费减状态"
                      v-model="form.reduction"
                      hide-details='auto'
                      outlined
                      clearable
                      :rules="required"
                      clear-icon="mdi-close-circle-outline"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row v-if="form.reduction === 1">
                  <v-col cols="12" md='12'>
                    <v-select
                      :items="[{ text: '70%', value: 70 },{ text: '85%', value: 85 }]"
                      label="费减比例"
                      v-model="form.reductionRatio"
                      hide-details='auto'
                      outlined
                      clearable
                      :rules="required"
                      clear-icon="mdi-close-circle-outline"
                    ></v-select>
                  </v-col>
                </v-row>
              
               <!-- 受理驳回/专利撤回/授权驳回 -->
              <div v-if="form.status >= 25 &&  form.status !== 27 && form.status !== 28 && form.status !== 32">
                <v-row>
                    <v-col cols="12" md="6">
                      <base-material-date
                        ref='date'
                        :rules="required"
                        hide-details='auto'
                        outlined
                        label='受理时间'
                        clear-icon="mdi-close-circle-outline"
                        v-model='form.acceptTimeStr'
                      >
                      </base-material-date>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" :readonly="form.acceptFeeStatus === 0" label="受理费用" outlined :rules="number" v-model="form.acceptFee"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <file-upload
                      label="证书上传(命名：专利号_受理通知书.pdf)"
                      outlined
                      prepend-icon=''
                      accept=".pdf"
                      :bucket='bucket'
                      @on-file='onAcceptFileName'
                      :lazy='false'
                      :hint="form.acceptFileName ? form.acceptFileName.replace(bucket, '') : ''"
                      persistent-hint
                    />
                  </v-col>
                </v-row>
              </div>

              <!-- 授权通过/已下证/已领证书 -->
              <div v-if="form.status === 30 ||  form.status === 35 || form.status === 36">

                <v-row>
                    <v-col cols="12" md="6">
                      <base-material-date
                        ref='date'
                        :rules="required"
                        hide-details='auto'
                        outlined
                        label='授权时间'
                        clear-icon="mdi-close-circle-outline"
                        v-model='form.authTimeStr'
                      >
                      </base-material-date>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" :readonly="form.authFeeStatus === 0" label="授权费用" outlined :rules="number" v-model="form.authFee"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <file-upload
                      label="证书上传(命名：专利号_授权通知书.pdf)"
                      outlined
                      prepend-icon=''
                      accept=".pdf"
                      :bucket='bucket'
                      @on-file='onAuthFileName'
                      :lazy='false'
                      :hint="form.authFileName ? form.authFileName.replace(bucket, '') : ''"
                      persistent-hint
                    />
                  </v-col>
                </v-row>
              </div>

              <!-- 授权通过/已下证/已领证书 -->
              <div v-if="form.status === 35 || form.status === 36">
                <v-row>
                    <v-col cols="12" md="6">
                      <base-material-date
                        ref='date'
                        :rules="required"
                        hide-details='auto'
                        outlined
                        label='授权发文时间'
                        clear-icon="mdi-close-circle-outline"
                        v-model='form.certTimeStr'
                      >
                      </base-material-date>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field hide-details="auto" :readonly="form.authFeeStatus === 0" label="授权费用" outlined :rules="number" v-model="form.authFee"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <file-upload
                      label="证书上传(命名：专利号_电子版证书.pdf)"
                      outlined
                      prepend-icon=''
                      accept=".pdf"
                      :bucket='bucket'
                      @on-file='onCertFileName'
                      :lazy='false'
                      :hint="form.certFileName ? form.certFileName.replace(bucket, '') : ''"
                      persistent-hint
                    />
                  </v-col>
                </v-row>
              </div>

                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field hide-details="auto" label="第几年年费(目前维护年度，非待缴费年度)" outlined :rules="number" placeholder="目前年费维护年度" v-model="form.yearCostNumber"></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { edit } from '@/api/patent/index.js'
  import FileUpload from '@/components/oss/Index.vue'

  export default {
    name: 'PatentEdit',
    components: {
      FileUpload
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-9]+.?[0-9]*$/.test(value) || '必须输入数字',
        ],
        bucket: 'yd-patent',
        form: {
          id: '',
          reduction: '',
          reductionRatio: '',
          patentCode: '',
          authTime: '',
          authTimeStr: '',
          authFileName: '',
          authFilePath: '',
          authFee: '',
          acceptFee: '',
          acceptTime: '',
          acceptTimeStr: '',
          acceptFileName: '',
          acceptFilePath: '',
          certTimeStr: '',
          certFileName: '',
          certFilePath: '',
          yearCostNumber: ''
        },
        defForm: {
          id: '',
          reduction: '',
          reductionRatio: '',
          patentCode: '',
          authTime: '',
          authTimeStr: '',
          authFileName: '',
          authFilePath: '',
          authFee: '',
          acceptFee: '',
          acceptTime: '',
          acceptTimeStr: '',
          acceptFileName: '',
          acceptFilePath: '',
          yearCostNumber: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.form.acceptTime = new Date(this.form.acceptTimeStr).getTime() / 1000
          this.form.authTime = new Date(this.form.authTimeStr).getTime() / 1000
          this.loading = true
          edit(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      onAcceptFileName (fileName) {
        this.form.acceptFileName = fileName ? `${this.bucket}/${fileName}` : this.form.acceptFileName
      },
      onAuthFileName (fileName) {
        this.form.authFileName = fileName ? `${this.bucket}/${fileName}` : this.form.authFileName
      },
      onCertFileName (fileName) {
        this.form.certFileName = fileName ? `${this.bucket}/${fileName}` : this.form.certFileName
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
          this.form.acceptFeeStatus = null
          this.form.authFeeStatus = null
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
